import React from 'react';

import { Alert, AlertText } from './DisableAlert.styles';

export const DisableAlert = () => (
  <Alert>
    <AlertText variant="xs">
      O envio de e-mails está em manutenção e encontra-se temporariamente
      indisponível.
    </AlertText>
  </Alert>
);
